"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ChartContainer, ChartTooltip, ChartTooltipContent, ChartLegend, ChartLegendContent, type ChartConfig } from "@/components/ui/chart";
import { Area, AreaChart, Bar, BarChart, CartesianGrid, XAxis, YAxis, ResponsiveContainer } from "recharts";
import { TrendingUp, FileText, Smartphone, ArrowUpRight, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const incomeData = [{
  month: "Jan",
  income: 4500
}, {
  month: "Feb",
  income: 4800
}, {
  month: "Mar",
  income: 4600
}, {
  month: "Apr",
  income: 5100
}, {
  month: "May",
  income: 5400
}, {
  month: "Jun",
  income: 5900
}];
const roiData = [{
  year: "2020",
  value: 100
}, {
  year: "2021",
  value: 120
}, {
  year: "2022",
  value: 150
}, {
  year: "2023",
  value: 190
}, {
  year: "2024",
  value: 240
}];
const chartConfig = {
  income: {
    label: "Net Income",
    color: "var(--chart-2)"
  },
  value: {
    label: "Portfolio Value",
    color: "var(--chart-2)"
  }
} satisfies ChartConfig;
export default function FinancialTransparency() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}